export default __webpack_public_path__ + "static/media/53_3_0.b4dcff27.png";